'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var TableBody = function (_Component) {
  _inherits(TableBody, _Component);
  function TableBody() {
    _classCallCheck(this, TableBody);
    return _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).apply(this, arguments));
  }
  _createClass(TableBody, [{
    key: 'render',
    value: function () {
      function render() {
        var data = this.props.data;
        return _react2['default'].createElement('tbody', null, data.length > 0 ? this.renderBodyWithData() : this.renderBodyWithNoData());
      }
      return render;
    }()
  }, {
    key: 'renderBodyWithNoData',
    value: function () {
      function renderBodyWithNoData() {
        var tableBodyMessage = this.props.tableBodyMessage;
        var numberOfColumns = this.getNumberOfColumns();
        return _react2['default'].createElement('tr', null, _react2['default'].createElement('td', {
          colSpan: numberOfColumns
        }, tableBodyMessage));
      }
      return renderBodyWithNoData;
    }()
  }, {
    key: 'renderBodyWithData',
    value: function () {
      function renderBodyWithData() {
        var _this2 = this;
        var data = this.props.data;
        var columnValues = this.columnValues();
        return data.map(function (row, idx) {
          return _this2.renderTableRow(row, idx, columnValues);
        });
      }
      return renderBodyWithData;
    }()
  }, {
    key: 'renderTableRow',
    value: function () {
      function renderTableRow(rowMap, rowIndex, columnValues) {
        var _this3 = this;
        return _react2['default'].createElement('tr', {
          key: rowIndex
        }, columnValues.map(function (columnValue) {
          var value = rowMap[columnValue];
          var key = rowIndex + columnValue;
          return _this3.renderTableCell(value, key);
        }));
      }
      return renderTableRow;
    }()
  }, {
    key: 'renderTableCell',
    value: function () {
      function renderTableCell(value, key) {
        var cellValue = value;
        if (value === null || value === undefined) {
          cellValue = '-';
        }
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.name) {
          cellValue = value.name;
        }
        return _react2['default'].createElement('td', {
          key: key
        }, cellValue);
      }
      return renderTableCell;
    }()
  }, {
    key: 'columnValues',
    value: function () {
      function columnValues() {
        var columns = this.props.columns;
        return columns.reduce(function (columnValues, column) {
          var childCount = column.childCount,
            isChild = column.isChild,
            value = column.value;
          if (childCount === 0 || isChild) {
            columnValues.push(value);
          }
          return columnValues;
        }, []);
      }
      return columnValues;
    }()
  }, {
    key: 'getNumberOfColumns',
    value: function () {
      function getNumberOfColumns() {
        return this.props.columns.reduce(function (counter, column) {
          var isChild = column.isChild,
            childCount = column.childCount;
          if (isChild) {
            counter += 1;
          } else if (childCount === 0) {
            counter += 1;
          }
          return counter;
        }, 0);
      }
      return getNumberOfColumns;
    }()
  }]);
  return TableBody;
}(_react.Component);
TableBody.propTypes = {
  columns: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
    value: _propTypes2['default'].string.isRequired,
    name: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].element]).isRequired,
    sorting: _propTypes2['default'].bool,
    sorter: _propTypes2['default'].func,
    customFilters: _propTypes2['default'].array,
    columns: _propTypes2['default'].array,
    isChild: _propTypes2['default'].bool,
    lastChild: _propTypes2['default'].bool,
    childCount: _propTypes2['default'].number
  })).isRequired,
  data: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object, _propTypes2['default'].number]))).isRequired,
  tableBodyMessage: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].element])
};
TableBody.displayName = 'DataTable-TableBody';
exports['default'] = TableBody;